require("./bootstrap");

require("./main");

require("./notification");

require("./stripe");

//require('./chatbot');

require("./messenger");

require("./owner/drop_photos");
